const RouterData = {
  login: {label: '', name: 'login', path: '/login'},
  register: {label: '注册', name: 'register', path: '/register'},
  forgetPass: {label: '忘记密码', name: 'forgetPassword', path: '/forgetPassword'},

  netDisk: {label: '网盘', name: 'netDisk', path: '/'},
  daiDing: {label: '待定', name: 'daiDing', path: '/daiDing'},
  emkt: {label: '商城', name: 'emkt', path: '/emkt'},

  allFile: {label: '全部文件', name: 'allFile', path: '/netDisk/allFile'},
  gcFile: {label: '吉凯', name: 'gcFile', path: '/netDisk/gcFile'},
  cusFile: {label: '个人', name: 'cusFile', path: '/netDisk/cusFile'},
  conFile: {label: '合同', name: 'conFile', path: '/netDisk/conFile'},
  tagFile: {label: '标签', name: 'tagFile', path: '/netDisk/tagFile'},
  delFile: {label: '回收站', name: 'delFile', path: '/netDisk/delFile'},
  myShare: {label: '我的分享', name: 'myShare', path: '/netDisk/myShare'},
  myCommon: {label: '公共文件', name: 'myCommon', path: '/netDisk/myCommon'},

  shared: {label: '分享', name: 'share', path: '/share'},
  inputPassCode: {label: '填写提取码', name: 'inputPassCode', path: '/passCode'}
}

const AppContentWindow = {
  app: 0,
  all: 1,
  genechem: 2,
  customer: 3,
  contract: 4,
  tag: 5,
  deleted: 6,
  toolBar: 10
}

const TagIds = {
  /**
   *  1: {class: 'el-icon-menu', label: '全部文件', name: 'allFile', path: '/netDisk/allFile'},
   2: {class: '', label: '吉凯', name: 'gcFile', path: '/netDisk/gcFile'},
   3: {class: '', label: '个人', name: 'cusFile', path: '/netDisk/cusFile'},
   4: {class: 'el-icon-tickets', label: '合同', name: 'conFile', path: '/netDisk/conFile'},
   5: {class: 'el-icon-star-on', label: '标签', name: 'tagFile', path: '/netDisk/tagFile'},
   6: {class: 'el-icon-delete', label: '回收站', name: 'delFile', path: '/netDisk/delFile'}
   */
  1: {class: 'el-icon-menu', label: '全部文件', name: RouterData.allFile.name, path: RouterData.allFile.path, addFlag: false},
  2: {class: 'el-icon-star-on', label: '标签', name: RouterData.tagFile.name, path: RouterData.tagFile.path, addFlag: true},
  100: {class: 'el-icon-share', label: '我的分享', name: RouterData.myShare.name, path: RouterData.myShare.path, addFlag: false},
  200: {class: 'el-icon-tickets', label: '公共文件', name: RouterData.myCommon.name, path: RouterData.myCommon.path, addFlag: false},
  1000: {class: 'el-icon-delete', label: '回收站', name: RouterData.delFile.name, path: RouterData.delFile.path, addFlag: false}
}

const LazyLoad = {
  startIndex: 0,
  pageSize: 20
}

const OperateFileType = {
  download: 1,
  moveToTag: 2,
  removeTag: 3,
  rename: 4,
  delete: 5
}

const Boolean = {
  yes: 1,
  no: 0
}

const BooleanTF = {
  yes: true,
  no: false
}

const SrcPage = {
  all: 1,
  tag: 2,
  delete: 3,
  myShare: 4,
  myCommon: 5
}

const UploadOrReleaseType = {
  cus: 1, // 用户发布
  gc: 2, // 本地文件发布
  erp: 3 // erp文件发布
}

const FileType = {
  'all': 1, // '全部文件',
  'gc': 2, // '吉凯文件',
  'cus': 3, // '个人文件',
  'common': 4, // '公共文件',
  'report': 5, // '实验报告',
  'bill': 6 // '报账单 ',
}

// dict 10006
const TagCategory = {
  all: 1,
  tag: 2,
  share: 100,
  common: 200,
  delete: 1000
}

const FileSource = {
  gc: 1,
  cus: 2
}

const OrderColumn = {
  fileName: 'fileName',
  fileSize: 'fileSize',
  updateDT: 'updateDT'
}

const UrlFlag = {
  fromEmail: 1,
  fromShare: 2,
  fromOw: 'ow'
}

const SendVeriCodeType = {
  register: 1,
  resetPass: 2,
  changePass: 3,
  login: 4
}

const loginSmsCodeResultStatus = {
  Login_By_SmsCode_Result_New_Customer: 1001, // 使用短信验证码登录，监测到为新用户
  Login_By_SmsCode_Result_Multi_CustomerNo: 1002 // 使用短信验证码登录，监测一个手机号对应多个客户编号
}

const InvalidExpire = {
  oneDay: 1,
  sevenDay: 2,
  oneMonth: 3,
  forever: 4
}

const ShareType = {
  regular: 1,
  common: 2
}

const DownloadFileTip = '老师您好，感谢您使用吉凯云下载您的专属实验报告。在您点击【确定】按钮后，即视为对报告的签收确认。如您对实验报告有任何疑问，请联系我司客服人员（客服热线：400-621-0302），我们将以最快的速度应答您的疑问。'

export default {
  RouterData,
  AppContentWindow,
  TagIds,
  LazyLoad,
  OperateFileType,
  SrcPage,
  UploadOrReleaseType,
  FileType,
  TagCategory,
  Boolean,
  OrderColumn,
  UrlFlag,
  SendVeriCodeType,
  InvalidExpire,
  ShareType,
  BooleanTF,
  FileSource,
  DownloadFileTip,
  loginSmsCodeResultStatus
}



// WEBPACK FOOTER //
// ./src/utils/constant.js